module.exports = __webpack_public_path__ + "img/194.e34c59b0.jpg";